import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import VideoActions from "../VideoActions/VideoActions";
import VideoThumbnail from "react-video-thumbnail";
import { faPlayCircle } from "@fortawesome/free-solid-svg-icons";
import UserPlaceholder from "assets/img/user.png";
import RoundLogo from "assets/img/ic_launcher_round.png";
import ImageContainer from "components/ImageContainer/ImageContainer";

const VideoListItem = ({
  v,
  showDefaultAvatar,
  iDx,
  allowActions,
  showAction,
  setReload,
  setVideoUrl,
  setVideoDetails,
}) => {
  const containerStyle = {
    position: "absolute",
    width: "100%",
    height: "unset",
    objectFit: "unset",
    borderRadius: "0.7rem",
  };

  return (
    <div key={`${iDx}-${v.title}`} className="videoListContainerItem">
      <div
        className="videoItemImage"
        onClick={() => {
          setVideoUrl(v.url);
          setVideoDetails({
            title: v.title,
            description: v.large_desc,
          });
        }}
        role="button"
      >
        <div style={containerStyle}>
          <span className="videoListAvatar">
            {v.thumbnail ? (
              <ImageContainer src={v.thumbnail} alt="" thumb={v.thumbnail} />
            ) : (
              <VideoThumbnail
                videoUrl={v.url}
                thumbnailHandler={(thumbnail) => (
                  <img src={thumbnail} alt="pollImage" />
                )}
                width={400}
                height={210}
              />
            )}
          </span>
        </div>

        <FontAwesomeIcon icon={faPlayCircle} className="playIcon" />

        {v?.is_forwarded && (
          <div className="forwardedTag">
            <div className="forwardedInfo d-flex gap-1">
              <img
                height={20}
                width={20}
                src={v?.original_post?.user?.avatar ?? UserPlaceholder}
                alt=""
              />
              <div>
                Shared by {v?.original_post?.user?.first_name} {v?.original_post?.user?.last_name} from{" "}
                {v?.original_post?.team?.name}
              </div>
            </div>
          </div>
        )}
      </div>
      <div className="d-flex justify-content-between videoActionContainer">
        <div className="d-flex gap-1">
          <img
            src={
              showDefaultAvatar ? RoundLogo : v?.user?.avatar ?? UserPlaceholder
            }
            alt=""
            height={45}
            width={45}
            className="videoUserAvtar"
          />
          <div className="d-flex flex-column">
            <div className="videoTitle">{v.title}</div>
            <div className="videoDesc">{v.short_desc}</div>
          </div>
        </div>

        {allowActions && showAction && (
          <VideoActions
            videoId={v.id}
            setReload={setReload}
            isForwarded={v?.is_forwarded}
          />
        )}
      </div>
    </div>
  );
};

export default VideoListItem;
